import { motion } from "framer-motion";
import { ChevronLeft } from "lucide-react";
import { Logo } from "../Logo";

export const TOTAL_STEPS = 10;

export const StepHeader = ({ step, onBack }) => (
  <div className="relative z-10 px-5 pt-5 pb-2" data-testid="onb-header">
    <div className="flex items-center justify-between">
      <button data-testid="onb-back-btn" onClick={onBack} disabled={step === 0}
        className="w-9 h-9 -ml-2 rounded-full flex items-center justify-center text-navy disabled:opacity-0 hover:bg-slate-100 transition">
        <ChevronLeft size={22} />
      </button>
      <Logo size={30} />
      <span data-testid="onb-step-label" className="text-[11px] font-bold uppercase tracking-widest text-slate-500 w-9 text-right">
        {Math.min(step + 1, TOTAL_STEPS)}/{TOTAL_STEPS}
      </span>
    </div>
    <div className="flex gap-1 mt-4" aria-hidden="true">
      {Array.from({ length: TOTAL_STEPS }, (_, i) => `seg-${i}`).map((id, i) => (
        <span key={id} className={`h-1 flex-1 rounded-full transition-colors duration-500 ${i <= step ? "bg-gradient-to-r from-royal to-turq" : "bg-slate-200"}`} />
      ))}
    </div>
  </div>
);

export const StepArt = ({ icon: Icon }) => (
  <div className="relative w-20 h-20 mx-auto mb-6">
    <div className="absolute inset-0 rounded-full bg-turq/15 blur-xl" />
    <div className="relative w-20 h-20 rounded-[28px] bg-white border border-slate-200 shadow-[0_12px_30px_-12px_rgba(37,99,235,.45)] flex items-center justify-center">
      <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-royal to-turq flex items-center justify-center text-white">
        <Icon size={24} strokeWidth={2.2} />
      </div>
    </div>
  </div>
);

export const StepTitle = ({ title, hint }) => (
  <div className="text-center mb-6">
    <h2 data-testid="onb-step-title" className="font-serif text-[26px] leading-tight font-bold text-navy tracking-tight">{title}</h2>
    {hint && <p className="text-slate-500 text-sm mt-2 leading-relaxed">{hint}</p>}
  </div>
);

const PANEL_INITIAL = { opacity: 0, x: 36 };
const PANEL_ANIMATE = { opacity: 1, x: 0 };
const PANEL_EXIT = { opacity: 0, x: -36 };
const PANEL_TRANSITION = { duration: 0.32, ease: [0.22, 1, 0.36, 1] };

export const StepPanel = ({ step, children }) => (
  <motion.div key={step} initial={PANEL_INITIAL} animate={PANEL_ANIMATE} exit={PANEL_EXIT} transition={PANEL_TRANSITION} className="w-full">
    {children}
  </motion.div>
);

export const PrimaryBtn = ({ children, ...p }) => (
  <button {...p} className="w-full bg-royal text-white font-bold py-3.5 rounded-2xl disabled:opacity-40 active:scale-[0.98] transition shadow-[0_10px_24px_-10px_rgba(37,99,235,.7)]">
    {children}
  </button>
);

export const Chip = ({ active, children, ...p }) => (
  <button {...p}
    className={`px-4 py-2.5 rounded-full text-sm font-semibold border transition-all active:scale-95 ${
      active ? "bg-royal text-white border-royal" : "bg-white text-navy border-slate-300 hover:border-royal"}`}>
    {children}
  </button>
);
